module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"IKIGAI Uruguay - Productos Naturales","short_name":"IKIGAI UY","start_url":"/","background_color":"#49b1be","theme_color":"#49b1be","display":"minimal-ui","icon":"src/images/ikigai-icon.png","description":"Importadora de productos naturales para salud y bienestar en Uruguay","lang":"es","categories":["shopping","health","lifestyle"],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"84b418d82d108c3e27f0aff23fe91afc"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-MMG2NEJJEM"],"gtagConfig":{"anonymize_ip":true},"pluginConfig":{"head":true,"respectDNT":true,"exclude":[],"origin":"https://www.googletagmanager.com","delayOnRouteUpdate":0}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
